/*
  全部页面引入
 */

import RestTable from "./RestTable";
import Food from "./Food";
import Base from "./Base";
import Printer from "./Printer";
import ConfirmSetting from "./ConfirmSetting";
import RestaurantPhoto from "./RestaurantPhoto";
const pages = {
  RestTable,
  Food,
  Base,
  Printer,
  ConfirmSetting,
  RestaurantPhoto
};
export default pages;
